<section class="flex w-full justify-end gap-4 pr-8 text-white">
  <div class="flex h-[200px] w-[350px] items-center justify-center">
    @if (!pieChartData?.datasets?.[0]?.data?.length) {
      @if (loading) {
        <div class="loading-spinner">
          <mat-spinner [diameter]="50"></mat-spinner>
        </div>
      } @else {
        <svg width="400" height="250px">
          <circle
            cx="200"
            cy="125"
            r="115"
            class="fill-black/10 stroke-gray-300 stroke-2 drop-shadow"
          ></circle>

          <text
            x="200"
            y="125"
            font-size="15"
            text-anchor="middle"
            fill="#ffffff"
          >
            No active orders
          </text>
        </svg>
      }
    } @else {
      <canvas
        class="drop-shadow"
        baseChart
        [data]="{
          labels: pieChartData.labels,
          datasets: [
            {
              label: 'Orders',
              data: pieChartData.datasets[0].data,
              backgroundColor: backgroundColor,
              hoverOffset: 4,
            },
          ],
        }"
        [labels]="pieChartData.labels"
        [type]="pieChartType"
        [options]="pieChartOptions"
        (chartClick)="chartClicked($event)"
        [type]="'pie'"
      >
      </canvas>
    }
  </div>

  <!-- Right: CTA -->
  <div class="self-end pl-2 text-right font-montserrat lg:pl-6 xl:pl-16">
    <a
      routerLink="/orders/insights"
      class="flex items-center justify-end gap-1 text-base font-medium text-white transition-opacity hover:opacity-75"
    >
      View order insights
      <mat-icon class="text-base">arrow_forward</mat-icon>
    </a>
    <p class="mt-1 text-xs text-white/40">
      Milestones, activation status,<br />and in-progress services
    </p>
  </div>
</section>
